import { FirebaseTimestampType } from 'firebase/index'
import { addSeconds, differenceInSeconds } from 'date-fns'

const getExpiredDate = (expiresAt: FirebaseTimestampType | undefined, expiresMaxage: number): Date => {
  const now = new Date()
  const expiresMaxageDate = addSeconds(now, expiresMaxage)
  if (!expiresAt) {
    // 固定期限が設定されていなければ相対期限の日付を返す
    return expiresMaxageDate
  } else if (expiresMaxage === 0) {
    // 相対期限が設定されていなければ固定期限の日付を返す
    return expiresAt.toDate()
  } else {
    // 固定期限と相対期限が設定されていれば近い方を返す
    const diff = differenceInSeconds(expiresAt.toDate(), new Date())
    return diff > expiresMaxage ? expiresAt.toDate() : expiresMaxageDate
  }
}

export default getExpiredDate
